import React,{useState} from 'react'
import '../comprartoken.css';
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import {toast,ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function ComprarToken() {
    const[detalhes,setDetalhes]=useState({contador:""});
    const [error,setError]=useState(null);
    const [nome,setNome]=useState(null);
    const [nuit,setNuit]=useState(null);
    const [bi,setBi]=useState(null);
    const[morada,setMorada]=useState(null);
    const[email,setEmail]=useState(null);
    const [telemovel,setTel]=useState(null);
    const [valor,setValor]=useState({contador:"",valor:"",unidade:"Mzn"});
    const [step,setStep]=useState({iva:"",m3:"",valg:"",tsc:"",mpag:""});
    const [te,setTe]=useState(null);
    const [token,setToken]=useState(null);
    const [phone,setPhone]=useState();
    const [pdiv,setPdiv]=useState(null);
    const Comprar=()=>{
        console.log(valor);
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/step_tarif/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:valor
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            step.iva=d.data.iva; 
            step.m3=d.data.m3;
            step.valg=d.data.metical; 
            step.tsc=d.data.tsc;  
            step.taxa_fixa=d.data.taxa_fixa;
            setTe("sds");
         }
       
           ).catch(e=>{
            toast.error('O valor de compra inferior a taxa Fixa Acumulada!')
            setError(e.message );
        })
    
    }
    const ComprarRecarga=()=>{axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/recarga/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{contador:valor.contador,
            valor:valor.valor,
           total:step.m3,
           numero:telemovel,
           totalg:step.valg,
           iva:step.iva,
           tsc:step.tsc,
           mpag:step.mpag,
           taxa_fixa:step.taxa_fixa}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( d=>{
        toast.success(`Compra efectuada com Sucesso`);
        
        setTe(null);
        setToken(d.data.recarga);
       
     }
   
       ).catch(e=>{
        setError(e.message );
        toast.error(`Credenciais invalidas! verifique o nome ou palavra passe`);
          
    })
}
    const BaixarFactura=()=>{axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/baixarfactura/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{contador:valor.contador,
            valor:valor.valor,
           total:step.m3,}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( d=>{
        toast.success(`Compra efectuada com Sucesso`);
       
     }
   
       ).catch(e=>{
        setError(e.message );
        toast.error(`Credenciais invalidas! verifique o nome ou palavra passe`);
          
    })
    }
    const EnviarFactura=()=>{axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/sendrecibo/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{contador:valor.contador,
            valor:valor.valor,
           total:step.m3,
           numero:phone}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( d=>{
        toast.success(`Enviado Com sucesso`);
       
     }
   
       ).catch(e=>{
        setError(e.message );
        toast.error(`Credenciais invalidas! verifique o nome ou palavra passe`);
          
    })
    }
    const CounterSeacrh=()=>{
        
        axios({
            method:"get",
            url:`${localStorage.getItem('url')}/web/contador/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            params:detalhes
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{ console.log(d.data); 
                        setNome(d.data.nome); 
                        setBi(d.data.bi);
                        setNuit(d.data.nuit);
                        setMorada(d.data.morada);
                        setTel(d.data.telemovel);
                        setEmail(d.data.email) ;
                        setValor({...valor,contador:detalhes.contador})}
                        
       
           ).catch(e=>{
            setError(e.message );
            toast.error(`O numero de contador introduzido nao consta na base de dados!`);
       
        })
         }
    const Pesquisa =e=>{
        e.preventDefault();
        console.log(detalhes);

        console.log("token "+ localStorage.getItem('token'));
        CounterSeacrh();    
    }
    const ComprarHadler=e=>{
        e.preventDefault();
        Comprar();
     }
    const ComprarHandle=e=>{
        e.preventDefault();
        ComprarRecarga();
        
      
     }
     const CancelarHandle=e=>{
        e.preventDefault();
        setNome(null);  
        setNuit(null);
        setTe(null);
       
     }
     const ImprimirHandle=e=>{
        e.preventDefault();
        BaixarFactura();
       
     }
     const EnviarHandle=e=>{
        e.preventDefault();
        setPdiv('gg');
     }
    return (
        <form className="comprar" onSubmit={Pesquisa}>
            <div className="procurar_cliente_contador">
            
            <label for="name">
                <span>Numero de Contador</span>
            </label>
        
            <input type="text" id="ipesqui" name="name" autoComplete='off' maxLength={13} onChange={e=> setDetalhes({...detalhes,contador:e.target.value}) } value={detalhes.contador} required/>
            <input type="submit" id="pesqui" value="Pesquisar"/>
                
            </div>
            {nome && <div className='informacoes'>
                <div id="colunap">
                    <div id="linha">
                        <div id="icon"><img  id="imagem"src={require('./images/man.png')}  />
                        </div>
                        <div id="text">Nome</div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={nome} required/></div>
                     </div>
                
                    <div id="linha">
                        <div id="icon"><img  id="imagem"src={require('./images/credit-card.png')}/>
                        </div>
                        <div id="text">NUIT:
                        </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value= {nuit} required/></div>
                    </div>

                    <div id="linha">
                    <div id="icon"><img  id="imagem"src={require('./images/driving-license.png')}  />
                        </div>
                        <div id="text">BI: </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={bi} required/></div>

                       
                    </div>
                
                </div>
                <div id="colunad">
                    <div id="linha">
                         <div id="icon"><img  id="imagem"src={require('./images/location.png')}  />
                                </div>
                        <div id="text">Morada:
                        </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={morada} required/></div>
                   
                    </div>
                     <div id="linha">
                          <div id="icon"> <img  id="imagem"src={require('./images/gmail.png')}  />
                                </div>
                          <div id="text">Email:
                          </div>
                          <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={email} required/></div>
                   
                        
                    </div>

                    <div id="linha">
                          <div id="icon"><img  id="imagem"src={require('./images/phone.png')}  />
                                </div>
                          <div id="text">Telemovel: 
                
                          </div>
                          <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={telemovel} required/></div>
                      
                    </div>
                
                </div>
              
            </div> 
           }
           {nuit && <div className="cart" ><label for="name">
                <span>Valor da Recarga</span>
            </label>
        
             <input type="text" id="icart" name="icart" onKeyPress={e=> {if(e.key=="Enter")e.preventDefault();}} autoComplete='off' maxLength={13} onChange={e=> setValor({...valor,valor:e.target.value}) } value={valor.valor} required/>
             <button value="heloo" id="pesqui" value="Comprar" onClick={ComprarHadler}>Comprar
             </button>
            </div>}
        {te && <div className='starif' > 
           	<p><img  id="imagem"src={require('./images/shopping-cart.png')}  />Deseja efectuar a compra?</p>
               <div id="text">Metodo de Pagamento</div>
                        <div id="inpu">
                        <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                            <option value="NUM">NUM</option>
                            <option value="MPESA">M-PESA</option>
                            <option value="MMOLA">E-MOLA</option>
                            <option value="MP24">conta movel</option>
                            <option value="MKESH">M-KESH</option>
                            <option value="MB">MultiBanco</option>
                                       </select>
                        </div>
                        
               <div id="colunap">
                    <div id="linha">
                        <div id="text">IVA</div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={step.iva} required/></div>
                     </div>
                
                    <div id="linha">
                        <div id="text">TSC:
                        </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value= {step.tsc} required/></div>
                    </div>

                    <div id="linha">
                        <div id="text">val: </div>
                        <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={step.valg} required/></div>

                       
                    </div>
                    <div id="linha">
                    <div id="text">Total m3: </div>
                    <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={step.m3} required/></div>

                   
                </div>
                <div id="linha">
                    <div id="text">TFP: </div>
                    <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={step.taxa_fixa} required/></div>

                   
                </div>
            
                </div>
               
            <div id="btns">
            <button value="heloo" id="pesqui" value="Sim" onClick={ComprarHandle}>Sim
             </button>
             <button value="heloo" id="pesqui" value="Nao" onClick={CancelarHandle} >Nao
             </button>
                
            </div>
        </div>  }
        {token && <div className='starif'>
            <div>Recarga: </div>
            <div id="inpu"><input disabled="true" type="text" id="icart" name="icart" value={token} required/></div>
            <div id="btns">
            <button value="heloo" id="pesqui" value="Imprimir" onClick={ImprimirHandle}>Imprimir
             </button>
             <button value="heloo" id="pesqui" value="Enviar" onClick={EnviarHandle} >Enviar
             </button>
                
            </div>
            </div>
            
        }
        {pdiv && <div className='starif' >
            <div>Numero de celular </div>
            <div id="inpu"><input type="text" id="icart" name="icart" onChange={e=>setPhone(e.target.value)} value={phone} required/></div>
            <div id="btns">
            <button value="heloo" id="pesqui" value="Imprimisr" onClick={EnviarFactura}>Enviar
             </button>
                
            </div>
            
          </div>}
        </form>
         )
}

export default ComprarToken
